import { Form, Tag } from 'antd';
import styled from 'styled-components';
import { EscrowDestinationsFiltersType } from './EscrowDetailsAccountDestination.types';

export const FiltersContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	flex-wrap: wrap;
	gap: 1rem;
	margin-bottom: 1rem;
`;

export const FiltersGroup = styled.div`
	display: flex;
	align-items: center;
	flex-wrap: nowrap;
	gap: 1rem;
`;

export const SearchContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 1rem;
	flex: 1 1 30rem;
	max-width: 30rem;
`;

export const FiltersForm = styled(Form<EscrowDestinationsFiltersType>)`
	display: flex;
	align-items: center;
	width: 100%;
	gap: 0.7rem;
	flex-wrap: wrap;
`;

export const FiltersFormItem = styled(Form.Item)`
	label {
		font-weight: bold;
		color: ${p => p.theme.text};
	}
`;

export const FilterChipsContainer = styled.div`
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	gap: 0.5rem;
	margin-bottom: 1rem;
`;

export const FilterChip = styled(Tag)`
	display: inline-flex;
	align-items: center;
	max-width: 100%;
	margin: 0;
	padding: 0.25rem 0.5rem;
	border-radius: 1rem;
	background-color: ${p => p.theme.primaryOpacity};
	border-color: ${p => p.theme.primary};
	color: ${p => p.theme.text};
	font-size: 0.75rem;
	white-space: normal;
	overflow-wrap: anywhere;

	.ant-tag-close-icon {
		display: inline-flex;
		margin-inline-start: 0.375rem;
		color: ${p => p.theme.primary};
	}
`;

export const ButtonActions = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
`;
